import React, { useState } from 'react';
import CommonModal from '../Components/CommonModal';
import { change_password } from '../services';
import CommonButton from '../Components/CommonButton';

const PASSWORD_REGEX = /^(?=.{8,}$)(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()]).*$/;
const PASSWORD_RULE_MSG = 'Password must be 8+ characters, include uppercase, lowercase, number & special character';

function SecuritySettings() {
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [apiError, setApiError] = useState('');
  // Common toast — same pattern used across the app for API responses
  const [toast, setToast] = useState({ show: false, message: '', type: 'success' });

  const showToast = (message, type = 'success') => {
    setToast({ show: true, message, type });
    setTimeout(() => setToast({ show: false, message: '', type: 'success' }), 4000);
  };

  const openModal = () => {
    setApiError('');
    setShowModal(true);
  };

  const closeModal = () => {
    setApiError('');
    setShowModal(false);
  };

  const onSubmit = async (data) => {
    setIsLoading(true);
    setApiError('');
    try {
      const params = {
        old_password: data.oldPassword,
        new_password: data.newPassword,
        confirm_password: data.confirmNewPassword,
      };

      const response = await change_password(params);
      const successMessage = response?.statusCode?.response_data?.data?.message;
      const errorMessage = response?.errors?.message;

      if (successMessage) {
        showToast(successMessage, 'success');
        setShowModal(false);
      } else if (errorMessage) {
        setApiError(errorMessage);
        showToast(errorMessage, 'error');
      } else {
        const fallback = 'Something went wrong while changing the password.';
        setApiError(fallback);
        showToast(fallback, 'error');
      }
    } catch (error) {
      console.error('Error:', error);
      const msg = error?.response?.data?.errors?.message || 'Something went wrong while changing the password.';
      setApiError(msg);
      showToast(msg, 'error');
    } finally {
      setIsLoading(false);
    }
  };

  const passwordFields = [
    {
      name: 'oldPassword',
      label: 'Old Password',
      type: 'password',
      placeholder: 'Type old password',
      required: 'Old password is required',
      maxLength: { value: 30, message: 'Maximum 30 characters' },
      pattern: { value: PASSWORD_REGEX, message: PASSWORD_RULE_MSG },
    },
    {
      name: 'newPassword',
      label: 'New Password',
      type: 'password',
      placeholder: 'Type new password',
      required: 'New password is required',
      maxLength: { value: 30, message: 'Maximum 30 characters' },
      pattern: { value: PASSWORD_REGEX, message: PASSWORD_RULE_MSG },
      validate: (value, all) => value !== all.oldPassword || 'New password must be different from old password',
    },
    {
      name: 'confirmNewPassword',
      label: 'Confirm New Password',
      type: 'password',
      placeholder: 'Re-type new password',
      required: 'Confirm new password is required',
      maxLength: { value: 30, message: 'Maximum 30 characters' },
      validate: (value, all) => value === all.newPassword || 'Confirm Passwords do not match',
    },
  ];

  return (
    <div>
      {/* Change Password Section */}
      <div className='d-flex gap-3 mb-3 align-items-center'>
        <img src='https://nmtsecurity-publicbucket.s3.us-west-2.amazonaws.com/dashboard/external-attack-surface-scan.svg' alt='external-attack-surface-scan' height={32} width={32} />
        <h3 className='color_white mb-0 font_20 font-600'>Change Password</h3>
      </div>

      <div className="companyProfileContainer">
        <section className="companyProfile">
          <div className='infoGrid pt-0'>
            <div>
              <p className='mb-0 font_14 color_light_blue'>Choose a unique password to protect your account</p>
              <p className='mb-0 gap-2 font_20 d-flex'>Password </p>
            </div>
            <CommonButton
              text="Change"
              onClick={openModal}
              className="btn_primary mt-4"
            />
          </div>
        </section>
      </div>

      {/* MFA Section */}
      {/* <div className='d-flex gap-3 mt-3 mb-3 align-items-center'>
        <img src='https://nmtsecurity-publicbucket.s3.us-west-2.amazonaws.com/dashboard/external-attack-surface-scan.svg' alt='external-attack-surface-scan' height={32} width={32} />
        <h3 className='color_white mb-0 font_20 font-600'>Multi-Factor Authentication</h3>
      </div>

      <div className="companyProfileContainer">
        <section className="companyProfile">
          <div className='infoGrid pt-0'>
            <div>
              <p className='mb-0 font_14 color_light_blue'>Multi-Factor Authentication</p>
              <p className='mb-0 gap-2 font_20 d-flex'>Two-Step Verification</p>
            </div>
            <div>
              <p className='mb-0 mt-4 font_20 font_500 blue_text'>Change</p>
            </div>
          </div>
        </section>
      </div> */}

      {/* Change Password Modal — common component with react-hook-form validation */}
      <CommonModal
        show={showModal}
        onHide={closeModal}
        title="Change Password"
        subtitle="Choose a unique password to protect your account."
        fields={passwordFields}
        defaultValues={{ oldPassword: '', newPassword: '', confirmNewPassword: '' }}
        onSubmit={onSubmit}
        error={apiError}
        buttons={[
          { text: 'Cancel', variant: 'secondary', onClick: closeModal, disabled: isLoading },
          { text: 'Submit', variant: 'primary', type: 'submit', loading: isLoading, loadingText: 'Submitting…' },
        ]}
      />

      {/* Toast — common alert pattern */}
      {toast.show && (
        <div className={`custom-toast ${toast.type}`}>
          <span className="icon">{toast.type === 'success' ? '✓' : '✕'}</span>
          <span className="message">{toast.message}</span>
          <button
            className="close-btn"
            onClick={() => setToast({ show: false, message: '', type: 'success' })}
          >
            ✕
          </button>
        </div>
      )}
    </div>
  );
}

export default SecuritySettings;
